export const COOKIE_EXPIRES_TIME = 86400;
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';